import classnames from 'classnames';
import type { JSX } from 'react';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { AnimatedChevronIcon, IconFail } from '../../BasicComponents/Icons';
import { HEADER_HEIGHT } from '../PlayerSidebar';
import { HideButton } from './HideButton';
import type { ItemStyle } from './types';

export type FavoriteHeaderProps = {
  style: ItemStyle;
  isOpen: boolean;
  anySelected: boolean;
  allHidden: boolean;
  onToggle: () => void;
  onClearSelection: () => void;
  onHide: () => void;
  onUnhide: () => void;
};

export function FavoriteHeader({
  style,
  isOpen,
  anySelected,
  allHidden,
  onToggle,
  onClearSelection,
  onHide,
  onUnhide,
}: FavoriteHeaderProps): JSX.Element {
  return (
    <div
      className={classnames('starter-list-header', { open: isOpen })}
      style={{
        ...style,
        height: HEADER_HEIGHT,
        zIndex: 1000 + (style.zIndex || 0),
      }}
    >
      <div
        className="starter-list-header-item"
        {...onClickGenerator(() => {
          if (anySelected) onToggle();
        })}
      >
        <div
          style={{
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            opacity: anySelected ? 1 : 0.5,
          }}
        >
          <AnimatedChevronIcon isOpen={isOpen} />
          &nbsp;
          <div className="starter-list-header-item-label">{t('list.FAVORITE')}</div>
          {anySelected && (
            <div
              className="starter-list-header-icon-button"
              {...onClickGenerator((event) => {
                event.stopPropagation();
                onClearSelection();
              })}
            >
              <IconFail />
            </div>
          )}
          {anySelected && <HideButton allHidden={allHidden} onHide={onHide} onUnhide={onUnhide} />}
        </div>
      </div>
    </div>
  );
}
